<!--
  - Copyright (c) 2019 brightlamp
  -->

<template>
    <v-container>
        <v-toolbar dense class="mb-2 indigo white--text" flat>
            <v-toolbar-title>Name & Address</v-toolbar-title>
        </v-toolbar>
        <v-row dense>
            <v-col md="12">
                <v-text-field
                        v-model="orgData.name"
                        label="Org Name"
                        :clearable="!readonly"
                        single-line
                        :readonly="readonly">
                </v-text-field>
            </v-col>
            <v-row>
                <v-col md="9">
                    <v-img
                        eager
                        max-height="171px"
                        max-width="171px"
                        :src=orgData.logo>
                    </v-img>
                </v-col>
                <v-col v-if="!readonly">
                    <v-btn color=green class="white--text" @click="uploadLogo()">Upload</v-btn>
                </v-col>
            </v-row>
            <v-col md="12">
                <v-text-field
                        v-model="orgData.address.addrLn1"
                        label="Address Line 1"
                        :clearable="!readonly"
                        single-line
                        :readonly="readonly">
                </v-text-field>
            </v-col>
            <v-col md="12">
                <v-text-field
                        v-model="orgData.address.addrLn2"
                        label="Address Line 2"
                        :clearable="!readonly"
                        single-line
                        :readonly="readonly">
                </v-text-field>
            </v-col>
            <v-col md="12">
                <v-text-field
                        v-model="orgData.address.city"
                        label="City"
                        :clearable="!readonly"
                        single-line
                        :readonly="readonly">
                </v-text-field>
            </v-col>
            <v-col md="12">
                <v-text-field
                        v-model="orgData.address.state"
                        label="State"
                        :clearable="!readonly"
                        single-line
                        :readonly="readonly">
                </v-text-field>
            </v-col>
            <v-col md="6">
                <v-text-field
                        v-model="orgData.address.pstlCd"
                        label="Postal Code"
                        :clearable="!readonly"
                        single-line
                        :readonly="readonly">
                </v-text-field>
            </v-col>
            <v-col md="6">
                <v-select
                        v-model="orgData.address.cntry"
                        :items="countries"
                        label="Country"
                        single-line
                        :readonly="readonly">
                </v-select>
            </v-col>
        </v-row>
        <OrgLogoDialog :dialog="orgLogoDialog" :orgId=orgData.id @dialog-close="closeOrgLogoDialog"/>
    </v-container>
</template>

<script>
    import OrgLogoDialog from '@/components/org-logo-dialog';
    import {mapState} from 'vuex';
    export default
    {
        name: 'org-name-address',
        components:
        {
            OrgLogoDialog
        },
        data: function ()
        {
            return {
                orgLogoDialog: false,
                countries:
                [
                    'Canada',
                    'Denmark',
                    'Turkey',
                    'United States'
                ]
            }
        },
        props:
        {
            readonly: true,
            orgData: {}
        },
        computed:
        {
            ...mapState('orgs',
            {
                logo: state => state.logo
            })
        },
        methods:
        {
            uploadLogo()
            {
                this.orgLogoDialog = true
            },
            closeOrgLogoDialog()
            {
                this.orgLogoDialog = false;
                this.orgData.logo = this.logo
            }
        }
    }
</script>

<style scoped>
</style>